import { Component, Input, OnInit } from '@angular/core';
import { RechtMasterListEntry, RechtMasterListEntryMeta } from '../../../core/gb-api';
import { KompaktGrundpfandrechtBeschreibungComponent } from '../../kompaktdarstellung/grundpfandrecht-beschreibung/kompakt-grundpfandrecht-beschreibung.component';
import { KompaktStandardRechtBeschreibungComponent } from '../../kompaktdarstellung/standardrecht-beschreibung/kompakt-standard-recht-beschreibung.component';

@Component({
  selector: 'cap-recht-beschreibung',
  templateUrl: './recht-list-beschreibung.component.html',
  imports: [KompaktGrundpfandrechtBeschreibungComponent, KompaktStandardRechtBeschreibungComponent]
})
export class RechtListBeschreibungComponent implements OnInit {
  @Input() item: RechtMasterListEntry | RechtMasterListEntryMeta;

  constructor() {}

  ngOnInit() {}
}
